import type { FaireProductEntity } from "../../entity_types/product";

export const p_8385gcvaxc: FaireProductEntity = {
  token: "p_8385gcvaxc",
  type: "product",
  name: "Mahj Dragons Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/a9c51eb245be6eec3485d773f0c1c5cb2ea1b562b8e7e0257005d12444b7cdc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bb11cada9d18deeca9feb907bd46d65367f184a53d3ae010f5683e3300469fc.jpeg",
    "https://cdn.faire.com/fastly/16d445874bcbec2e8c627c2db87902379bd5eb6cc70b3e7f09ecfe4f7127ca44.jpeg",
    "https://cdn.faire.com/fastly/c32938aad70b0bec93440cdbae33d0e80424aefa9a2400dbe2fe53bf33b7e043.jpeg",
    "https://cdn.faire.com/fastly/61a2643df0fdba2211e1ccaadd9735c75feffdf9d9499ed358fe9ac0d4b9e4b2.jpeg",
    "https://cdn.faire.com/fastly/3232db309cd9f3b1a9ac2199ffda441b646e32b6f27fadcb139e57f157984b1f.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:45.887Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
